import * as jwt_decode from 'jwt-decode';

export function getDepartmentFromToken(token) {
    const cforceAttribute = 'custom:cforce';
    const decoded = jwt_decode(token);

    return JSON.parse(decoded[cforceAttribute]).department;
}
